import { render, staticRenderFns } from "./GameHome.vue?vue&type=template&id=21fd2bd8&scoped=true"
import script from "./GameHome.vue?vue&type=script&lang=js"
export * from "./GameHome.vue?vue&type=script&lang=js"
import style0 from "./GameHome.vue?vue&type=style&index=0&id=21fd2bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd2bd8",
  null
  
)

export default component.exports